import React, { useState } from 'react';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import makeStyles from '@mui/styles/makeStyles';

import { Title } from '../../';

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(3),
		display: 'flex',
		overflow: 'auto',
		flexDirection: 'column'
	},
	fixedHeight: {
		height: 120
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	}
}));

export default function NotFoundError({ listing }) {
	const classes = useStyles();
	return (
		<Grid container>
			<Grid item xs={12}>
				<Paper className={classes.paper}>
					{listing ? (
						<Title>Listing {listing} not found.</Title>
					) : (
						<Title>We could not find a listing with that ID.</Title>
					)}
				</Paper>
			</Grid>
		</Grid>
	);
}
